
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { EPaymentChannel, ISplitBillPayeeOpt } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 空中分账-分账账户-分账-余额
 */
export async function queryBalanceDetail(params: {channelId: number; companyId?: number}) {
  let data = {} as {availableAmount: number};

  try {
    const { code, context, message } = await Http.get<any>(`${hostUrl}/pay/payer/wallet-info`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {} as any;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 空中分账-分账账户-分账-收款方下拉
 */
export async function queryPayeeList(params: { channelType: EPaymentChannel; companyId?: number }) {
  let data: ISplitBillPayeeOpt[] = [];

  try {
    const { code, context, message } = await Http.get<any>(`${hostUrl}/pay/payee/list`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 空中分账-分账账户-分账-确认订单
 */
export async function commitOrder(param) {
  let data = {};

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/pay/payer/commit`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 空中分账-分账账户-分账复核-确认复核（旧接口用的是支付）
 */
export async function payOrder(param) {

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/order/audit/agree`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');

    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

/**
 * 空中分账-分账账户-分账复核-复核拒绝
 */
export async function refuseCheck(param) {

  try {
    const { code, message } = await Http.post<any>(`${hostUrl}/pay/order/audit/refuse`, param);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');

    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}

